import React, { useCallback, useEffect, useState } from 'react';
import LangContext from './LangContext';
import en from '../../locales/en.json';
import ru from '../../locales/ru.json';
var LOCALES = {
    en: en,
    ru: ru
};
var LangProvider = function (_a) {
    var children = _a.children, _b = _a.lang, lang = _b === void 0 ? 'en' : _b;
    var _c = useState('en'), language = _c[0], changeLanguage = _c[1];
    useEffect(function () {
        changeLanguage(lang);
    }, [lang]);
    var resolveObjectKey = function (object, key) {
        try {
            var pathArray = key.split('.');
            return pathArray.reduce(function (res, item) {
                return res[item];
            }, object);
        }
        catch (e) {
            return key;
        }
    };
    var t = useCallback(function (key) {
        return resolveObjectKey(LOCALES[language || 'en'], key);
    }, [language]);
    return (React.createElement(LangContext.Provider, { value: {
            t: t,
            language: language
        } }, children));
};
export default LangProvider;
//# sourceMappingURL=LangProvider.js.mapimport React, { useCallback, useEffect, useState } from 'react';
import LangContext from './LangContext';
import en from '../../locales/en.json';
import ru from '../../locales/ru.json';
var LOCALES = {
    en: en,
    ru: ru
};
var LangProvider = function (_a) {
    var children = _a.children, _b = _a.lang, lang = _b === void 0 ? 'en' : _b;
    var _c = useState('en'), language = _c[0], changeLanguage = _c[1];
    useEffect(function () {
        changeLanguage(lang);
    }, [lang]);
    var resolveObjectKey = function (object, key) {
        try {
            var pathArray = key.split('.');
            return pathArray.reduce(function (res, item) {
                return res[item];
            }, object);
        }
        catch (e) {
            return key;
        }
    };
    var t = useCallback(function (key) {
        return resolveObjectKey(LOCALES[language || 'en'], key);
    }, [language]);
    return (React.createElement(LangContext.Provider, { value: {
            t: t,
            language: language
        } }, children));
};
export default LangProvider;
//# sourceMappingURL=LangProvider.js.map